module.exports = "/_next/static/images/DownloadApp_DesktopView-067982fa6a27518b47dae2d8096af648.png";